jQuery(document).ready(function(){

    jQuery('.interactive_btn').click(function(){
      jQuery(this).parent('.interactive_card').toggleClass("interactive_card_active");
      jQuery(this).toggleClass('interactive_btn_active');
    });


    jQuery('#sec_facial_parts_call').hide();
    jQuery('#third_facial_parts').hide();
    jQuery('#third_facial_parts_call').hide();

    jQuery('#sec_facial_parts').click(function(){
        jQuery('#sec_facial_parts_call').show();
        jQuery('.sec_facial_cont').hide();
        jQuery('#third_facial_parts').show();
    });
    jQuery('#third_facial_parts').click(function(){
        jQuery('.third_facial_cont').hide();
        jQuery('#third_facial_parts_call').show();
    });

});


const links = document.links; 
  for (let i = 0, linksLength = links.length ; i < linksLength ; i++) { 
    if (links[i].hostname !== window.location.hostname) { 
      links[i].target = '_blank'; 
      links[i].rel = 'noreferrer noopener'; 
  } 
}